import { createUseStyles } from 'react-jss';

import { hideScrollbars, ITheme, mediaQuery, mozScrollbars, scrollbars } from '../../../styles';

const useStyles = createUseStyles<string, { sidebarSize: string }, ITheme>(
  ({ breakpoints, layout }: ITheme) => ({
    root: {
      '--header-height': '60px',
      '--sidebar-width': (props) => props.sidebarSize,

      display: 'flex',
      flexDirection: 'column',

      height: '100vh',
      maxHeight: '-webkit-fill-available',

      background: 'var(--x-bg-1)',
    },
    header: {
      width: '100%',
      height: 'var(--header-height)',

      display: 'flex',
      alignItems: 'center',
      padding: '16px 40px',

      background: 'var(--x-bg-1)',
      borderBottom: `1px solid var(--x-border-2)`,

      [mediaQuery(breakpoints.laptop)]: {
        padding: '12px',
        justifyContent: 'center',
      },
    },
    body: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'auto',

      [mediaQuery(breakpoints.laptop)]: {
        flexDirection: () => 'column',
      },
    },
    main: {
      flex: 1,
      background: layout.background,

      overflow: 'auto',
    },
    mainContent: {
      width: '100%',
      height: '100%',

      overflow: 'auto',

      ...hideScrollbars,
      ...scrollbars(),
      ...mozScrollbars(),
    },
    sidebar: {
      width: 'var(--sidebar-width)',

      background: 'var(--x-bg-1)',
      borderLeft: `1px solid var(--x-border-2)`,

      overflow: 'auto',

      [mediaQuery(breakpoints.laptop)]: {
        width: '100%',
        maxHeight: '50%',

        borderTop: `1px solid var(--x-border-2)`,
        borderLeft: 'none',
      },
    },
    sidebarContent: {
      width: '100%',
      height: '100%',

      overflow: 'auto',

      ...hideScrollbars,
      ...scrollbars(),
      ...mozScrollbars(),
    },
  }),
  {
    name: 'layout-with-sidebar',
  },
);

export default useStyles;
